import React from 'react';
import styled from 'styled-components';
import { IRadioItemProps } from './IRadioItemProps';
import { mergeTests } from '../../test-utilities/mergeTests';

const StyledRadioSwitchInput = styled.input<IRadioItemProps>`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
`;

const StyledSwitchItemLabel = styled.label`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const StyledSwitchText = styled.div<{ checked: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) => props.theme.fonts.mixins.smallButton}
  text-transform: uppercase;

  color: ${(props) => (props.checked ? props.theme.colors.defaultContentBackground : props.theme.colors.primary)};
  background-color: ${(props) =>
    props.checked ? props.theme.colors.primary : props.theme.colors.defaultContentBackground};

  cursor: pointer;
  padding: ${(props) => props.theme.spacing.spacing4} ${(props) => props.theme.spacing.spacing2};
  position: relative;
  width: 100%;
  height: 100%;
  &:hover {
    color: ${(props) => props.theme.colors.activeControlText};
    background-color: ${(props) => props.theme.colors.activeControlBackground};
  }
`;

export const RadioSwitchItem: React.FC<IRadioItemProps> = (props) => {
  const { id, value, label } = props;
  const dataTestClass = props['data-test-class'] || 'radio-switch-item';
  return (
    <StyledSwitchItemLabel htmlFor={id} data-test-class={mergeTests(dataTestClass, 'label')}>
      <StyledRadioSwitchInput {...props} type="radio" data-test-class={mergeTests(dataTestClass, 'input')} />
      <StyledSwitchText checked={props.checked} data-test-class={mergeTests(dataTestClass, 'text')}>
        {label || value}
      </StyledSwitchText>
    </StyledSwitchItemLabel>
  );
};
